import { render } from "./YoutubePlayer.vue?vue&type=template&id=170c6356"
import script from "./YoutubePlayer.vue?vue&type=script&lang=js"
export * from "./YoutubePlayer.vue?vue&type=script&lang=js"

import "./YoutubePlayer.vue?vue&type=style&index=0&id=170c6356&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__